import gql from "graphql-tag";

import BrandFragment from "./brand.fragment";

const ProductFragment = gql`
  fragment ProductFragment on Product {
    id
    detail
    name
    url
    originalPrice
    actualPrice
    tierPrices {
      quantity
      price
      clientGroup
    }
    displayPrice
    promotion
    discount
    weight
    volume
    image
    isExclu
    isNew
    isTopVente
    isIncontournable
    isDispoWhiskyLive
    stars
    outOfStock
    brand {
      ...BrandFragment
    }
    presale
    presaleShippingDate
    availabilityLabel
    activationDate
    activationDateTimestamp
    shortDescription
    longDescription
    expertSignature
    productFamily
    productSubFamily
    originCountry
    originRegion
    merchant
    strength
    quota
    age
    tourbe
    packaging
    reference
    line
    vintage
    codeCertifBio
    nature {
      id
      label
    }
    tasting {
      key
      value
    }
    rewards
    metaTitle
    metaDescription

    mainType {
      name
      url
    }
    subType {
      name
      url
    }
    distillerie {
      name
      url
    }
    country {
      name
      url
    }
    region {
      name
      url
    }
    negociant {
      name
      url
    }

    sample
    sampleMessage

    infoMessages
    errorMessages
    errorCodes
    sku

    productRating
    productReviewCount
    productReviews {
      author
      description
      review_rating
    }
    tagBlocCms
  }
  ${BrandFragment}
`;

export default ProductFragment;
